import { Swiper } from 'swiper';
import { Navigation } from 'swiper/modules';

const sliders = document.querySelectorAll('.block-cards .swiper');

if (sliders.length > 0) {
	sliders.forEach((slider) => {
		const settings = {
			loop: true,
			grabCursor: true,
			spaceBetween: 50,
			slidesPerView: 1,
			speed: 1000,
			modules: [Navigation],
			navigation: {
				prevEl: slider.parentElement.querySelector(
					'.swiper-button-prev'
				),
				nextEl: slider.parentElement.querySelector(
					'.swiper-button-next'
				),
			},
			breakpoints: {
				576: {
					slidesPerView: 2,
				},
				768: {
					slidesPerView: 2,
				},
				992: {
					slidesPerView: 3,
				},
			},
		};

		new Swiper(slider, settings);
	});
}
